export default "__VITE_ASSET__rmt$YXhV__"